import { parse } from "date-fns";
import type { IsoDate } from "@/ui-kit";
import { isIsoDate } from "@/ui-kit";

export const DateTimeUtils = {
  toUTCStartOfDay(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return new Date(Date.UTC(year, month, day, 0, 0, 0, 0)).toISOString();
  },

  toUTCEndOfDay(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return new Date(Date.UTC(year, month, day, 23, 59, 59, 999)).toISOString();
  },

  /**
   * Parses an ISO datetime string (e.g., "2025-11-01T00:00:00.000Z")
   * as a local date, ignoring timezone conversion.
   * Used for date-only fields where timezone should not affect the day.
   *
   * @param isoString - ISO 8601 datetime string
   * @returns Date object at midnight in local timezone
   */
  parseISODateOnly(isoString: string): Date {
    return parse(isoString.split("T")[0], "yyyy-MM-dd", new Date());
  },

  /** The API's date-only value ("2025-11-01T00:00:00.000Z") as its calendar day. */
  fromApiDate(value: string | null | undefined): IsoDate | null {
    const date = value?.slice(0, 10) ?? "";
    return isIsoDate(date) ? date : null;
  },

  /** A calendar day as the API stores date-only values: UTC midnight. */
  toApiDate(date: IsoDate | null): string {
    return date ? `${date}T00:00:00.000Z` : "";
  },
};
